/**
 * KAN-735: необязательное поле "Стоимость покупки, ₽" в мастере подключения и
 * формах импорта. Ошибка видна сразу под полем; форма не отправляется, пока она есть.
 */
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { validatePurchaseCost } from '@/lib/telegramConnect';

interface Props {
  value: string;
  disabled?: boolean;
  onChange: (value: string) => void;
}

export function PurchaseCostField({ value, disabled, onChange }: Props): JSX.Element {
  const error = validatePurchaseCost(value);
  return (
    <div className="space-y-1">
      <Label htmlFor="connect-purchase-cost">Стоимость покупки, ₽ (необязательно)</Label>
      <Input
        id="connect-purchase-cost"
        data-testid="connect-purchase-cost-input"
        inputMode="decimal"
        autoComplete="off"
        placeholder="Например, 600"
        value={value}
        disabled={disabled}
        aria-invalid={!!error}
        onChange={(e) => onChange(e.target.value)}
      />
      {error && (
        <p className="text-xs text-red-600" data-testid="connect-purchase-cost-error">
          {error}
        </p>
      )}
    </div>
  );
}
